import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

export const Seo = ({ title, description }) => {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {SITE && <link rel="canonical" href={url} />}
      {SITE && <meta property="og:url" content={url} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};
